<template>
  <div class="selfcontrol__wrapper w-full lg:w-[800px] mx-auto">
    <div v-for="(givenAnswer, index ) in data" :key="index" class="">
      <freetext-selfcheck
          v-if="index === currentIndex"
          :question-text="questionText"
          :given-answer="givenAnswer.text"
          :question-id="givenAnswer.question_id"
          :test="test"
          :exam="exam"
          :correct-answer="getCorrectAnswer( givenAnswer.question_id )"
          @answered="showNext"
      />
    </div>
<!--    <div v-if="result" class="p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg" role="alert">-->
<!--      <span class="font-medium">Fertig!</span>-->
<!--    </div>-->
  </div>
</template>

<script>
import {updateTest} from '../../api/TestApi'

export default {
  name: 'SelfControl',

  props: {
    exam: Object,
    test: Object,
    data: Array,
  },
emits: ['finished'],

  data() {
    return {
      questionText: null,
      currentIndex: 0,
      result: null,
    }
  },

  methods: {
    /**
     * Go through all questions and look in the choices for the correct answer
     * to the given answer/question_id
     *
     * @param questionId
     */
    getCorrectAnswer: function (questionId) {
      let correctAnswer = null
      this.exam.questions.map(question => {
        // Answer is in choices but text questions only have on choice so take index 0
        if (question.id === questionId) {
          this.questionText = question.text
          correctAnswer = question.choices[0].text
        }
      })
      return correctAnswer
    },

    showNext: async function (answer) {

      this.currentIndex++

      if( this.currentIndex >= this.data.length ) {
        let data = {
          action: 'finish',
        }
        this.result = await updateTest( this.test.id, data )
        this.$emit('finished', this.result )
      }
    },
  },
}
</script>

<style scoped>

</style>
